import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "image-container"
};
const _hoisted_2 = {
  class: "like-unlike"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "like-unlike"
};
const _hoisted_5 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_row, {
    class: "colshow"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_col, {
      span: "6"
    }), _createVNode(_component_van_col, {
      span: "4",
      class: "colshow"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: $data.imglike_show,
        onClick: _cache[0] || (_cache[0] = (...args) => $options.like && $options.like(...args)),
        class: "imageshow"
      }, null, 8, _hoisted_3)])]),
      _: 1
    }), _createVNode(_component_van_col, {
      span: "4",
      offset: "4",
      class: "colshow"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: $data.imgunlike_show,
        onClick: _cache[1] || (_cache[1] = (...args) => $options.unlike && $options.unlike(...args)),
        class: "imageshow"
      }, null, 8, _hoisted_5)])]),
      _: 1
    }), _createVNode(_component_van_col, {
      span: "6"
    })]),
    _: 1
  })]);
}